export default __webpack_public_path__ + "static/media/Brinjal.8cb50197.jpg";